function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7463 1C13.0846 1 13.3731 1.13224 13.6119 1.39671C13.8706 1.64085 14 1.93584 14 2.28169V10.0939C14 10.4601 13.8706 10.7754 13.6119 11.0399C13.3731 11.284 13.0846 11.4061 12.7463 11.4061H8.26866L9.55224 13.3592V14H4.44776V13.3592L5.73134 11.4061H1.28358C0.925373 11.4061 0.616915 11.284 0.358209 11.0399C0.119403 10.7754 0 10.4601 0 10.0939V2.28169C0 1.93584 0.119403 1.64085 0.358209 1.39671C0.616915 1.13224 0.925373 1 1.28358 1H12.7463ZM12.7463 8.81221V2.28169H1.28358V8.81221H12.7463Z",
  fill: "#55586F"
});

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.b83b3c06.svg";
export { ForwardRef as ReactComponent };